'use strict';
'use client';
import { j as e } from "../../external/react/jsx-runtime.js";
import n from "../../external/react-modal/lib/index.js";
import { FontAwesomeIcon as g } from "../../external/@fortawesome/react-fontawesome/index.es.js";
import { faClose as y } from "../../external/@fortawesome/pro-regular-svg-icons/index.js";
import v from "./MessageView.js";
import { getFullName as w } from "../../helpers/doctorUtils.js";
import s from "./chat.module.scss.js";
import "../../external/classnames/index.js";
import { useState as N } from "react";
import "../Provider/index.js";
import b from "../Form/Input.js";
import C from "../Loading/index.js";
n.setAppElement("body");
const T = ({
  messages: c,
  onSendMessage: a,
  onModalClose: l,
  hasMoreMessages: u,
  onEndReached: f,
  open: d,
  identity: h,
  doctor: i,
  isLoading: p = !1,
  readonly: x = !1
}) => {
  const m = () => {
    l && l(!1);
  }, j = w(i), [o, t] = N("");
  return /* @__PURE__ */ e.jsxs(
    n,
    {
      id: "chat-modal",
      isOpen: d,
      onAfterClose: () => l(!0),
      className: s.window,
      overlayClassName: s.overlay,
      onRequestClose: m,
      shouldCloseOnOverlayClick: !0,
      children: [
        /* @__PURE__ */ e.jsxs("div", { className: s.header, children: [
          /* @__PURE__ */ e.jsxs("div", { children: [
            /* @__PURE__ */ e.jsx("h5", { children: j }),
            /* @__PURE__ */ e.jsx("small", { children: "Usually responds within 24 hours" })
          ] }),
          /* @__PURE__ */ e.jsx(
            "button",
            {
              "aria-label": "close",
              onClick: m,
              className: s.close,
              children: /* @__PURE__ */ e.jsx(g, { icon: y })
            }
          )
        ] }),
        /* @__PURE__ */ e.jsx("div", { className: "w-full h-full overflow-auto flex flex-col", children: p ? /* @__PURE__ */ e.jsx("div", { className: "flex flex-col h-full w-full items-center justify-center bg-white text-grey-400", children: /* @__PURE__ */ e.jsx(C, {}) }) : /* @__PURE__ */ e.jsxs(e.Fragment, { children: [
          /* @__PURE__ */ e.jsx(
            v,
            {
              messages: c,
              identity: h,
              doctor: i,
              hasMoreMessages: u,
              onEndReached: f
            }
          ),
          !x && /* @__PURE__ */ e.jsxs(
            "form",
            {
              className: "p-4",
              onSubmit: (r) => {
                r.preventDefault(), a(o), t("");
              },
              children: [
                /* @__PURE__ */ e.jsx(
                  "label",
                  {
                    htmlFor: "message-input",
                    className: "sr-only",
                    children: "Message"
                  }
                ),
                /* @__PURE__ */ e.jsx(
                  b,
                  {
                    id: "message-input",
                    autoFocus: !0,
                    chat: !0,
                    placeholder: "Type your message...",
                    value: o,
                    showFeedback: !1,
                    onSubmit: () => {
                      a(o), t("");
                    },
                    onChange: (r) => t(r.target.value)
                  }
                )
              ]
            }
          )
        ] }) })
      ]
    }
  );
};
export {
  T as default
};
